import React, { useCallback, memo, useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as yup from "yup";
import { Grid } from "@mui/material";
import { Form } from "react-final-form";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate } from "react-router-dom";
import Stack from "@mui/material/Stack";
import FormControlLabel from "@mui/material/FormControlLabel";
import UiSwitch from "../../../_uiComponents/common/form/UiSwitch";
import UiSelect from "../../../_uiComponents/common/form/UiSelect";
import {
     UiButton,
     UiBackButton,
} from "../../../_uiComponents/common/form/UiButton";
import UiInnerSearchWr from "../../../_uiComponents/common/UiInnerSearchWr";
import UiLookUpDataInputWr from "../../../_uiComponents/dataManagement/LookupDataInputWr";
import UiTagsInput from "../../../_uiComponents/common/form/UiTagsInput";
import Validator from "../../../../_helpers/validate.schema";
import {
     lookupTableTypesRequest,
     lookupTableAddRequest,
     lookupTableUpdateRequest,
} from "../../../../_redux/_actions";
import { FORM_TYPE_ADD, FORM_TYPE_EDIT } from "../../../../_helpers/constants";
import UiInput from "../../../_uiComponents/common/form/UiInput";

const validateSchema = () =>
     yup.object().shape({
          name: yup.string().required("Name is required."),
     });

const onValidate = async (values) => {
     return await Validator(values, validateSchema);
};

export default function CreateLookUpTableForm(props) {
     const [contains, setContains] = React.useState("");
     const [initialValues, setInitialValues] = React.useState({});
     // const [labelTags, setLabelTags] = useState([]);
     let navigate = useNavigate();
     let labelTags = useRef([]);

     const actionDispatch = useDispatch();

     // useEffect(() => {
     //      actionDispatch(lookupTableTypesRequest());
     // }, []);

     useEffect(() => {
          setInitialValues(props.initialValues);
     }, [props.initialValues]);

     const { tableTypes } = useSelector((state) => {
          return {
               tableTypes: state.lookupTable.types,
          };
     });

     const handleClick = () => {
          //  clear input value
          setContains("");
     };

     const handleSelecetedTags = (items) => {
          if(items.length <= 5){
               labelTags.current = [...items];
          }
     };

     const submit = async (values) => {

          if (props.type === FORM_TYPE_EDIT) {
               actionDispatch(
                    lookupTableUpdateRequest({
                         id: props.initialValues.id,
                         ...values,
                         labels: labelTags.current,
                         navigate,
                    }),
               );
          } else {
               actionDispatch(
                    lookupTableAddRequest({
                         ...values,
                         labels: labelTags.current,
                         navigate,
                    }),
               );
          }
     };

     return (
          <>
               <Form
                    onSubmit={submit}
                    validate={onValidate}
                    initialValues={
                         props.type === FORM_TYPE_EDIT && initialValues
                    }
                    render={({ form, handleSubmit, values }) => (
                         <form onSubmit={validateSchema}>
                              <>
                                   <UiInnerSearchWr>
                                        <Grid container spacing={2}>
                                             <UiLookUpDataInputWr>
                                                  <Grid container spacing={2}>
                                                       <Grid
                                                            item
                                                            xs={12}
                                                            lg={6}
                                                       >
                                                            <UiInput
                                                                 type="text"
                                                                 label="Name"
                                                                 name="name"
                                                                 maxLength={50}
                                                                 allowedCharacters={/^[a-zA-Z0-9_ ]+$/}
                                                            />
                                                       </Grid>
                                                       </Grid>
                                                       <Grid container spacing={2}>
                                                       <Grid
                                                            item
                                                            xs={12}
                                                            lg={6}
                                                            sx={{mt:1}}
                                                       >
                                                            <UiTagsInput
                                                                 formValue={
                                                                      values
                                                                 }
                                                                 selectedTags={
                                                                      handleSelecetedTags
                                                                 }
                                                                 fullWidth
                                                                 variant="outlined"
                                                                 id="labels"
                                                                 name="labels"
                                                                 label="Labels"
                                                                 tags={
                                                                      props.type ===
                                                                      FORM_TYPE_ADD
                                                                           ? ""
                                                                           : props
                                                                                  .initialValues
                                                                                  .labels
                                                                 }
                                                            />
                                                       </Grid>
                                                       </Grid>
                                                       <Grid container spacing={2}>
                                                       <Grid
                                                            item
                                                            xs={12}
                                                            lg={6}
                                                       >
                                                       <FormControlLabel
                                                            control={
                                                                 <UiSwitch
                                                                      name="active"
                                                                      checked={
                                                                           props.type ==
                                                                           FORM_TYPE_ADD
                                                                                ? false
                                                                                : props
                                                                                       .initialValues
                                                                                       .active
                                                                      }
                                                                 />
                                                            }
                                                            label="Active"
                                                            labelPlacement="top"
                                                            sx={{ mt: 2 }}
                                                            className="sba-lookup-switch-label"
                                                       />
                                                       </Grid>
                                                  </Grid>
                                             </UiLookUpDataInputWr>

                                             <Grid item xs={12}>
                                                  <Stack
                                                       spacing={2}
                                                       direction="row"
                                                       justifyContent="space-between"
                                                       alignItems={"center"}
                                                       sx={{ width: "100%" }}
                                                  >
                                                       <UiBackButton
                                                            size="small"
                                                            onClick={() =>
                                                                 navigate(-1)
                                                            }
                                                       />
                                                       <div className="sbt-right-action-btn-wr">
                                                            <UiButton
                                                                 onClick={() => {
                                                                      form.reset();
                                                                      setInitialValues(
                                                                           {},
                                                                      );
                                                                 }}
                                                                 name="Clear"
                                                                 variant="outlined"
                                                                 size="small"
                                                            />
                                                            <UiButton
                                                                 name={
                                                                      props.type ==
                                                                      FORM_TYPE_ADD
                                                                           ? "Save"
                                                                           : "Update"
                                                                 }
                                                                 variant="contained"
                                                                 size="small"
                                                                 onClick={useCallback(() => {
                                                                      handleSubmit();
                                                                 }, [])}
                                                            />
                                                       </div>
                                                  </Stack>
                                             </Grid>
                                        </Grid>
                                   </UiInnerSearchWr>
                              </>
                         </form>
                    )}
               />
          </>
     );
}
